import { Component } from 'src/utils';
import logoIcon from './../../../images/small-logo.png';
import houseIcon from './../../../images/house-icon.png';
import template from './store-detail.html';

@Component({
  controllerAs: 'storeDetail',
  template
})

export default class StoreDetail {
  static $inject = [
    '$scope',
    '$ngRedux',
    'spinnerService',
    'authService',
    '$stateParams',
    '$window',
    '$state',
    'APP'
  ];

  constructor($scope, $ngRedux, $spinner, $auth,    $stateParams,
    $window,
    $state,
    APP) {
    const disconnect = $ngRedux.connect(this.mapState)(this);
    this.logoIcon = logoIcon;
    this.houseIcon = houseIcon;
    this.$stateParams = $stateParams;
    this.$window = $window;
    this.$auth = $auth;
    this.$state = $state;
    this.APP = APP;
    this.onMarkerClick = this.onMarkerClick.bind(this);

    $spinner.show('appSpinner');
    if (!$auth.isGuestLogin()) {
      $auth.getUserProfile()
          .then(success => $auth.getStoreDetail(success.data.store.storeURLName))
    .finally(() => $spinner.hide('appSpinner'));
    }
    else {
      let guestStore = $auth.getGuestStoreDetail();
      $auth.getStoreDetail(guestStore.storeName)
          .finally(() => $spinner.hide('appSpinner'));

    }


    $scope.$on('$destroy', disconnect);
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var d = new Date();
    this.dayName = days[d.getDay()];
  }

  mapState(state) {
    return {
      profile: state.auth.profile,
      store: state.auth.storeDetail
    };
  }

  goToHomePage() {
    let storeName = '';
    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    } else {
      if (this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
        storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if (storeName) {
      this.$window.location.href = '/' + storeName;
    } else {
      this.$state.go('home');

    }
  }

  getStoreTiming(date) {
    const fordate = date || new Date();
    const mapping = {
      '0': 'Sunday',
      '1': 'Monday',
      '2': 'Tuesday',
      '3': 'Wednesday',
      '4': 'Thursday',
      '5': 'Friday',
      '6': 'Saturday'
    };
    const day = mapping[fordate.getDay()];
    return this.store.storeTimings && this.store.storeTimings.filter(el => el.day === day)[0];
  }

  storeClosingTime(forDate) {
    if (this.store.storeTimings) {
      let today = forDate || new Date();
      const close = this.getStoreTiming(forDate).closeTime;
      const hours = close.split(':')[0];
      const minutes = close.split(':')[1];
      today.setHours(hours);
      today.setMinutes(minutes);
      return today;
    }
  }

  storeOpeningTime(forDate) {
    if (this.store.storeTimings) {
      let today = forDate || new Date();
      const close = this.getStoreTiming(forDate).openTime;
      const hours = close.split(':')[0];
      const minutes = close.split(':')[1];
      today.setHours(hours);
      today.setMinutes(minutes);
      return today;
    }
  }

  formattedTime(dateTime) {
    const date = dateTime ? new Date(dateTime) : new Date();
    const hours = date.getHours() <= 12 ? date.getHours() : date.getHours() - 12;
    let time = (hours < 10 ? `0${hours}` : hours) + ':' +
      (date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes());
    const ampm = date.getHours() >= 12 ? ' PM' : ' AM';
    return time + ampm;
  }

  // function asssumes the time is passed as 24hr colon separated string e.g. 02:30
  changeStringtoDateObject(stringTime) {
    let timeArray = stringTime.split(':');
    let hours = timeArray[0];
    let minutes = timeArray[1];
    let timeObject = new Date();
    timeObject.setMinutes(minutes);
    return timeObject.setHours(hours);
  }

  onMarkerClick() {
    window.open(
      'http://maps.google.com/?daddr=' +
      `${this.store.addressLine1}, ${this.store.city}, ${this.store.state.name}`
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/order/store-detail/store-detail.js